<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="noticia-view mb-4">
      <div class="page-title" style="background-color: #000;">
        <div class="auto-container">
          <div class="titulo white" v-html="fc_removeHTML(item.titulo)"></div>
        </div>
      </div>
      <div class="noticia-content" style="padding-bottom: 0px;">
        <div class="auto-container">
          <div class="flex flex-wrap">
            <div class="title-column w-full lg:w-6 lg:pl-2 lg:pr-2">
              <div class="inner-column">
                <div class="title-group" style="margin-bottom:0;">
                  <span class="sectionTitle" v-html="fc_removeHTML(item.titulo)"></span>
                  <div class="subtitulo" v-html="item.subtitulo"></div>
                </div>
              </div>
            </div>
            <div class="image-column w-full lg:w-6 lg:pl-2">
              <div class="inner-column">
                <img :src="item.imagem" alt="">
              </div>
            </div>
            <div class="text-column w-full">
              <div class="inner-column">
                <div class="conteudo" v-html="item.conteudo"></div>
              </div>
            </div>
          </div>
          <div class="btn flex w-full lg:w-5 mt-3" v-if="(item.anexo != null)">
            <div @click="fc_dialogPdf(item.anexo, item.anexoNome.toUpperCase())" class="btn-redireciona flex" v-html="fc_getText(null, 'btn_verDocumento')"></div>
          </div>
        </div>
      </div>
    </div>
    <BannerContactos tipo="2" />
    <BannerRedesSociais />
  </div>
</template>

<script>
import BannerRedesSociais from '@/components/BannerRedesSociais.vue';
import BannerContactos from '@/components/BannerContactos.vue';
export default {
  components: {
    BannerRedesSociais,
    BannerContactos
  },
  data() {
    return {
      loaded: false,
      item: {},
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.id = this.$route.params.id;
      if (this.id == null) { this.fc_goRoute('home'); }
      else { this.mt_loadData(); }
    },
    mt_loadData() {
      this.fc_fetch({ endpoint: 'Noticias/' + this.id + '/', method: 'GET', success: this.mt_loadData_success, error: () => { this.mt_goBack(); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.item != null) {
        this.item = response.item;
        this.loaded = true;
      } else {
        this.fc_goRoute('home');
      }
    },
    mt_goBack() {
      if (this.$store.state.prevRoute == null || (this.$store.state.prevRoute.name != 'home' && this.$store.state.prevRoute.name != 'noticias')) {
        this.fc_goRoute('home');
      } else {
        this.fc_goBack();
      }
    }
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<style scoped>
  .noticia-content {
    padding: 80px 0px;
    position: relative;
  }
  .noticia-content .image-column .inner-column,
  .noticia-content .text-column .inner-column {
    padding-top: 30px;
  }
  .noticia-content .image-column img {
    display: inline-block;
    max-width: 100%;
    height: auto;
    max-height: 500px;
  }
</style>
